import React from "react";
import { Badge } from "@mantine/core";

const chipStyle = {
	margin: 4,
	overflow: "hidden",
	whiteSpace: "nowrap",
	textOverflow: "ellipsis",
	textTransform: "none",
	fontWeight: "normal",
};

const smallChipStyle = {
	...chipStyle,
	height: "22px",
};

const rootStyle = {
	display: "flex",
	justifyContent: "left",
	flexWrap: "wrap",
	overflow: "hidden",
};

export default function ChipsArray(props) {
	return (
		<div
			style={
				props.ignoreRootClass
					? props.style || null
					: { ...rootStyle, ...(props.style || {}) }
			}
		>
			{props.chips.map((data) => {
				return (
					<Badge
						key={data.key}
						variant="default"
						className={data.chipClass || ""}
						style={{
							...(props.useSmallChips
								? smallChipStyle
								: chipStyle),
							...(data.style || {}),
							cursor: data.handleClick ? "pointer" : undefined,
						}}
						title={data.title || null}
						rightSection={
							data.handleDelete ? (
								<span
									onClick={data.handleDelete}
									style={{ cursor: "pointer" }}
								>
									×
								</span>
							) : null
						}
						onClick={data.handleClick || null}
					>
						{data.label}
					</Badge>
				);
			})}
		</div>
	);
}
